import React from 'react';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';

const YellowStar = withStyles({
  root: {
    color: "#f3ba37"
  }
})(Star);
const actionFactories = {
  createCopyDocsUrlAction(copyToClipboard) {
    return (row) => {
      return {
        icon: () => /* @__PURE__ */ React.createElement(ShareIcon, { fontSize: "small" }),
        tooltip: "Click to copy documentation link to clipboard",
        onClick: () => copyToClipboard(`${window.location.origin}${row.resolved.docsUrl}`)
      };
    };
  },
  createStarEntityAction(isStarredEntity, toggleStarredEntity) {
    return (row) => {
      const entity = row.entity;
      const isStarred = isStarredEntity(entity);
      return {
        cellStyle: { paddingLeft: "1em" },
        icon: () => isStarred ? /* @__PURE__ */ React.createElement(YellowStar, null) : /* @__PURE__ */ React.createElement(StarBorder, null),
        tooltip: isStarred ? "Remove from favorites" : "Add to favorites",
        onClick: () => toggleStarredEntity(entity)
      };
    };
  }
};

export { actionFactories };
//# sourceMappingURL=actions.esm.js.map
